<div>
  <ul class="nav nav-tabs line-tab">
    <li *ngFor="let tab of tabs; let i = index" class="nav-item" role="presentation">
      <a
        [id]="tab.id + '-link'"
        [href]="'#' + tab.id"
        [class.active]="i === 0"
        [attr.aria-selected]="i === 0"
        class="nav-link"
        data-toggle="tab"
        role="tab"
        (click)="handleClick($event, tab.id)">
        {{ tab.label }}
      </a>
    </li>
  </ul>
  <ng-content select="#tab-content"></ng-content>
</div>
